import { Auth0Auth } from './auth0-auth';
import { FusionAuthAuth } from './fusionauth-auth';

export class AuthFactory {
  static createFusionAuth() {
    return new FusionAuthAuth();
  }
  static createAuth0() {
    return new Auth0Auth();
  }
} 